import styled from 'styled-components';
import Field from '@lendi-ui/field';

// some of scenarios we add padding to each child components which means the hidden field will also has padding.
export const HiddenLUIField = styled(Field)`
  margin: 0 !important;
  padding: 0 !important;
`;

export const HiddenLUIInputDiv = styled.div`
  display: none;
`;
